<script>
import Calendar from "../Calendar.vue";

export default {
  name: "BookAppointmentQuestion",
  components: {Calendar}
}
</script>

<template>
<div>
  <calendar />
</div>
</template>

<style scoped>

</style>